module.exports = __webpack_public_path__ + "f280c6fd500f0972cfac3e84dbd7edc0.webp";